package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
enum class DifficultyTier {
    EASY,
    MEDIUM,
    HARD,
    EXPERT,
}
